import en from "./locales/en";
import th from "./locales/th";

export default {
  en,
  th,
};
